/**
 * Trivial coordinate class
 */
class Coord {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    if (isNaN(x) || isNaN(y)) {
      throw new Error(`NaN encountered: ${x}/${y}`);
    }
    this.x = x;
    this.y = y;
  }
}

export default Coord;
